import axios, { Axios } from 'axios';
import { IHTTP, RequestConfig, Response } from './types';

export class HTTP implements IHTTP {

    private readonly _http: Axios;

    constructor(config?: RequestConfig) {
        if (! config) {
            this._http = axios;
        } else {
            this._http = new Axios(config);
        }
    }

    getUri(config?: RequestConfig<any>): string {
        return this._http.getUri(config);
    }
    request<T = any, R = Response<T>, D = any>(config: RequestConfig<D>): Promise<R> {
        return this._http.request(config);
    }
    get<T = any, R = Response<T>, D = any>(url: string, config?: RequestConfig<D>): Promise<R> {
        return this._http.get(url, config);
    }
    delete<T = any, R = Response<T>, D = any>(url: string, config?: RequestConfig<D>): Promise<R> {
        return this._http.delete(url, config);
    }
    head<T = any, R = Response<T>, D = any>(url: string, config?: RequestConfig<D>): Promise<R> {
        return this._http.head(url, config);
    }
    options<T = any, R = Response<T>, D = any>(url: string, config?: RequestConfig<D>): Promise<R> {
        return this._http.options(url, config);
    }
    post<T = any, R = Response<T>, D = any>(url: string, data?: D, config?: RequestConfig<D>): Promise<R> {
        return this._http.post(url, data, config);
    }
    put<T = any, R = Response<T>, D = any>(url: string, data?: D, config?: RequestConfig<D>): Promise<R> {
        return this._http.put(url, data, config);
    }
    patch<T = any, R = Response<T>, D = any>(url: string, data?: D, config?: RequestConfig<D>): Promise<R> {
        return this._http.patch(url, data, config);
    }
    postForm<T = any, R = Response<T>, D = any>(url: string, data?: D, config?: RequestConfig<D>): Promise<R> {
        return this._http.postForm(url, data, config);
    }
    putForm<T = any, R = Response<T>, D = any>(url: string, data?: D, config?: RequestConfig<D>): Promise<R> {
        return this._http.putForm(url, data, config);
    }
    patchForm<T = any, R = Response<T>, D = any>(url: string, data?: D, config?: RequestConfig<D>): Promise<R> {
        return this._http.patchForm(url, data, config);
    }
}

export default new HTTP();
